<div *ngIf="!unsubscribed" class="container">
  <h1>Скасування передплати</h1>
  <h3 class="mb-4">Нам шкода, що ви вирішили скасувати передплату Anima.</h3>
  <p class="">Підтвердьте, будь ласка, свій вибір і ми більше не стягуватимемо автоматичну оплату.
  </p>
  <p class="mb-3">
    Ми постійно оновлюємо тести та вдосконалюємо наш продукт, тому будемо раді бачити вас знову при нагоді!
  </p>
<!--  <p *ngIf="error" class="text-danger">-->
<!--    {{error}}-->
<!--  </p>-->
  <button *ngIf="auth.userData" class="action" (click)="onSubmit()">Підтвердити скасування</button>
<!--  <button *ngIf="!auth.userData" class="action" (click)="onSubmit()">Підтвердити скасування</button>-->
  <p *ngIf="!auth.userData">Залогінтесь щоб відписатись</p>
</div>

<div *ngIf="unsubscribed" class="container">
  <h1>Передплата скасована</h1>
  <h3 class="mb-4">Дякуємо, що скористалися Anima. Ваша передплата успішно скасована. </h3>
  <p class="">Вам має надійти відповідний лист.</p>
  <p class="mb-3"> Ви завжди зможете поновити передплату коли матимете потребу.</p>

<!--  <p *ngIf="error" class="text-danger">-->
<!--    {{error}}-->
<!--  </p>-->
  <a href="/" class="action">На головну</a>
</div>
<app-footer></app-footer>
